import React from 'react';
import withIcon from '../utilities/withIcon';

const IconSearch = () => {
  return (
    <g>
      <path d="M6.5 0C10.09 0 13 2.912 13 6.503a6.477 6.477 0 0 1-1.404 4.037l4.183 4.18a.75.75 0 0 1-1.06 1.061l-4.183-4.18A6.502 6.502 0 0 1 0 6.503 6.502 6.502 0 0 1 6.5 0zm0 1.5c-2.761 0-5 2.24-5 5.003a5.001 5.001 0 1 0 10 0 5.001 5.001 0 0 0-5-5.002z" />
    </g>
  );
};

export default withIcon(IconSearch);
